import { c as _c } from "react/compiler-runtime";
import { assertUnreachable } from "@/helpers/AllowlistToolHelpers";
import PrimaryButton from "@/components/utils/button/PrimaryButton";
import { CreateDropType } from "../types";
export default function CreateDropDesktopFooter(t0) {
  const $ = _c(7);
  const {
    disabled,
    type,
    loading,
    onDrop
  } = t0;
  let t1;
  if ($[0] !== type) {
    t1 = () => {
      switch (type) {
        case CreateDropType.DROP:
          {
            return "Drop";
          }
        case CreateDropType.QUOTE:
          {
            return "Quote";
          }
        default:
          {
            assertUnreachable(type);
            return "";
          }
      }
    };
    $[0] = type;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getText = t1;
  const t2 = getText();
  let t3;
  if ($[2] !== disabled || $[3] !== loading || $[4] !== onDrop || $[5] !== t2) {
    t3 = <div className="tw-pt-4 tw-border-t tw-border-solid tw-border-x-0 tw-border-b-0 tw-border-iron-700"><div className="tw-gap-x-3 tw-flex tw-justify-end"><PrimaryButton onClicked={onDrop} disabled={disabled} loading={loading} padding="tw-px-4 tw-py-2.5">{t2}</PrimaryButton></div></div>;
    $[2] = disabled;
    $[3] = loading;
    $[4] = onDrop;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}